/* eslint-disable react/no-array-index-key */

import React, { type ReactNode } from 'react';
import type { UseMutateFunction } from '@tanstack/react-query';
import type {
    BasketPrizeCertificateSummary,
    PrizeCertificateModel,
    RemovePrizeCertificateParams,
    RemovePrizeCertificateSuccess
} from 'autogen/swagger/all';
import { useDeliveryRemovePrizeCertificateMutation } from 'autogen/swagger/all/hooks';
import { updateBasket } from 'components/basket/shared/basket';
import ActivePrizeCertificateLine from './ActivePrizeCertifcateLine';

export type RemoveActivePrizeCertificate = UseMutateFunction<
    RemovePrizeCertificateSuccess,
    unknown,
    { params: RemovePrizeCertificateParams },
    unknown
>;

type ActivePrizeCertificatesSummaryRendererProps = Record<string, any> & {
    model: BasketPrizeCertificateSummary;
    renderer?: (
        model: PrizeCertificateModel,
        removeActivePrizeCertificateFunc: RemoveActivePrizeCertificate,
        props
    ) => ReactNode;
};

export default function ActivePrizeCertificatesSummaryRenderer({
    model: { prizeCertificates },
    renderer = (prizeCertificateModel, mutationFunc, props) => (
        <ActivePrizeCertificateLine
            {...props}
            model={prizeCertificateModel}
            removeActivePrizeCertificateFunc={mutationFunc}
        />
    ),
    ...restProps
}: ActivePrizeCertificatesSummaryRendererProps) {
    const { mutate } = useDeliveryRemovePrizeCertificateMutation({
        onSuccess: () => {
            updateBasket();
        }
    });

    return (
        <>
            {prizeCertificates.map((prizeCertificateModel, index) => (
                <React.Fragment key={index}>{renderer(prizeCertificateModel, mutate, restProps)}</React.Fragment>
            ))}
        </>
    );
}
